<template>
  <v-rating
    v-model="ratingState"
    @input="update()"
    :empty-icon="defaultIcon"
    :full-icon="highlightedIcon"
    :readonly="readOnly"
    hover
    dense
    small
    clearable
    :color="color"
    background-color="grey lighten-1"
    :size="size"
  />
</template>
<script>
import { ratingFromScore, scoreFromRating } from './ratingHelper';

export default {
  name: 'Rating',
  data: () => ({
    ratingState: 0,
    hasBeenChanged: false,
    defaultIcon: 'fa-gem',
    highlightedIcon: 'fa-gem',
  }),
  methods: {
    update() {
      if (!this.readonly) {
        this.hasBeenChanged = true;
        const newScore = scoreFromRating(this.ratingState);
        this.$emit('change', newScore);
      } else {
        this.ratingState = ratingFromScore(this.score);
      }
    },
  },
  props: {
    size: {
      type: Number,
      default: 22,
    },
    score: {
      type: Number,
      default: undefined,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'gray darken-3',
    },
  },
  watch: {
    score() {
      if (!this.hasBeenChanged) {
        this.ratingState = ratingFromScore(this.score);
      }
    },
  },
  created() {
    if (this.score !== -1) {
      this.ratingState = ratingFromScore(this.score);
    }
  },
};
</script>
